import { useEffect, useState } from "react";

export const HERO_IMAGES = ["/site/uk-bikes-hills.jpg", "/site/slider3-1.jpg", "/site/uk-bike-village.jpg", "/site/blood-cars.jpg", "/site/uk-team-morning.jpg", "/site/slider2-1.jpg"];
export const STRIP = ["/site/riders.jpg", "/site/volunteer1.jpg", "/site/car-crew.jpg", "/site/volunteer2.jpg", "/site/controller.jpg", "/site/volunteer3.jpg", "/site/fundraising.jpg", "/site/volunteer4.jpg", "/site/slider-1.jpg", "/site/volunteer5.jpg", "/site/uk-team-morning.jpg", "/site/volunteer6.jpg"];

export const HeroSlideshow = ({ images = HERO_IMAGES, interval = 6000 }) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((x) => (x + 1) % images.length), interval);
    return () => clearInterval(t);
  }, [images.length, interval]);
  return (
    <div className="absolute inset-0 overflow-hidden" data-testid="hero-slideshow" data-slide={i}>
      {images.map((src, n) => (
        <img key={src} src={src} alt="" aria-hidden className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-[1800ms] ${n === i ? "kenburns opacity-100" : "opacity-0"}`} />
      ))}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0d0e11]/70 via-[#0d0e11]/45 to-[#0d0e11]" />
    </div>
  );
};

export const PhotoMarquee = ({ images = STRIP, reverse = false }) => (
  <div className="relative overflow-hidden py-2" data-testid="photo-marquee">
    <div className={`flex w-max gap-4 ${reverse ? "marquee-rev" : "marquee"}`}>
      {[...images, ...images].map((src, n) => (
        <img key={n} src={src} alt="SSCBB volunteers and vehicles" loading="lazy" className="h-44 w-64 shrink-0 rounded-2xl object-cover shadow-xl ring-1 ring-white/10 transition-transform duration-500 hover:scale-105 sm:h-56 sm:w-80" />
      ))}
    </div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0d0e11]" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0d0e11]" />
  </div>
);

export const Reveal = ({ children, className = "", delay = 0 }) => {
  const [el, setEl] = useState(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!el) return undefined;
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setShown(true); io.disconnect(); } }, { threshold: 0.15 });
    io.observe(el);
    return () => io.disconnect();
  }, [el]);
  return <div ref={setEl} style={{ transitionDelay: `${delay}ms` }} className={`transition-[opacity,transform] duration-700 ${shown ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"} ${className}`}>{children}</div>;
};

export const CountUp = ({ to, suffix = "" }) => {
  const [n, setN] = useState(0);
  useEffect(() => {
    let raf;
    const start = performance.now();
    const step = (t) => {
      const p = Math.min(1, (t - start) / 1600);
      setN(Math.round(to * (1 - (1 - p) ** 3)));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [to]);
  return <>{n.toLocaleString("en-GB")}{suffix}</>;
};

export const Eyebrow = ({ children }) => <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#FEDC19]">{children}</p>;
